import * as React from "react";
import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
import "./MediaCard.css";
import { useSelector } from "react-redux";
import { fetchCurrentState } from "../../../../redux/features/customerViewSlice";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Virtual } from "swiper";
import { v4 } from "uuid";
import { useNavigate } from "react-router-dom";
import { ChipTitle, dateDDMM, onlySpaces } from "../../../../util";
import guest from "../../../../assets/images/guest.svg";
// import getCurrencySymbol from 'currency-symbol-map'
// import { bookingStatusWrapper } from '../../../../util'
import { mediaViewModel } from "../../customerViewDataModel";
import calender_icon from "../../../../assets/images/icons/calender_icon.svg";
// import booking_icon from '../../../../assets/images/icons/booking_icon.svg'
import SwiperButtonNext from "../../../common/swiperNextSlide";
import SwiperButtonPrev from "../../../common/swiperPrevSlide";
import { isEmpty } from "lodash";
import leftArrow from "../../../../assets/images/icons/media-left-arrow.svg";
import rightArrow from "../../../../assets/images/icons/media-right-arrow.svg";
import ChipTag from "../../../common/ChipTag";
import TextTruncate from "react-text-truncate";
import leisureDayBig from "../../../../assets/images/leisure-day-big-grey.svg";
import { useMemo } from "react";
import confirmed_icon from "../../../../assets/images/icons/confirmed_icon.svg";
import { useRef } from "react";
import { useEffect } from "react";
import MediaSlides from "./MediaSlides";
import { useState } from "react";
import newLeft from "../../../../assets/images/icons/new-left.svg";
import newRight from "../../../../assets/images/icons/new-right.svg";
import { height } from "dom7";
import {
  analyticsEvent,
  eventName,
} from "../../../common/Analytics/AnalyticsEvent";

export default function DaySlides({
  day,
  handleDetailPageOpen,
  handleNext,
  handlePrev,
  stayViewData,
  setisMediaMuted,
  isMediaMuted,
  detailPageState,
}) {
  // console.log('Day Slides>>>')
  const navigate = useNavigate();
  // const nextDayRef = useRef()
  // const prevDayRef = useRef()

  // let nextDayRefList = []
  // let prevDayRefList = []
  // nextDayRefList.push(nextDayRef)
  // prevDayRefList.push(prevDayRef)

  const swiper = useSwiper();

  const [showNext, setshowNext] = useState(false);
  const [showPrev, setshowPrev] = useState(true);
  // console.log('>>>>>>>nextDayRef:: ', nextDayRef)

  // console.log(swiper)

  return (
    <div>
      {/* Dates Navigation Slider */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {isEmpty(day.prevDate) && !day.prevDay ? (
          <div>
            <p
              onClick={() => {
                analyticsEvent.clickEvent(
                  "Media",
                  eventName.Media_intro_selected
                );
                navigate("/triplanding");
                // navigate(-1)
              }}
              className="headline2"
              style={{
                color: "var(--primaryShades20)",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <img
                  style={{ maxWidth: "7px", marginRight: "5px" }}
                  src={leftArrow}
                  alt="left-arrow"
                ></img>
                Intro
              </span>
              {/* {'Intro'} */}
            </p>
          </div>
        ) : (
          // <SwiperButtonPrev
          //   prevDayRef={prevDayRefList[prevDayRefList.length - 1]}
          // >
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              color: "var(--primaryShades20)",
              cursor: "pointer",
            }}
            className="headline2"
            onClick={() => {
              analyticsEvent.clickEvent(
                "Media",
                eventName.Media_previous_day_selected
              );
              handlePrev();
            }}
          >
            <img
              style={{
                maxWidth: "7px",
                marginRight: "5px",
                width: "12px",
                height: "12px",
              }}
              src={leftArrow}
              alt="left-arrow"
            ></img>
            {day.prevDate
              ? dateDDMM(day.prevDate)
              : isEmpty(day.prevDate) && day.prevDay
              ? "Day: " + day.prevDay
              : ""}
          </span>
          /* </SwiperButtonPrev> */
        )}

        <div
          className="truncated"
          style={{
            display: "flex",
            textAlign: "center",
            flex: "0 0 55%",
            justifyContent: "center",
            marginTop: "18px",
            marginBottom: "18px",
          }}
        >
          {/* <p className="truncated"> */}
          <span>
            <img
              src={calender_icon}
              style={{
                objectFit: "none",
                marginRight: "5px",
                width: "16px",
              }}
              alt="calender_icon"
            ></img>
          </span>
          <p className="headline2">
            {isEmpty(day.date)
              ? "Day " + day.currentDay + ": "
              : dateDDMM(day.date) + ": "}
          </p>
          <p className="body3 truncated" style={{ marginLeft: "5px" }}>
            {day.place_title}
          </p>
          {/* <TextTruncate
              line={1}
              element="span"
              truncateText="…"
              text={day.place_title}
              containerClassName="body3"
              style={{
                // color: 'white',
                // lineHeight: '22.5px',
                marginLeft: '2px',
              }}
            /> */}
          {/* </p> */}
        </div>

        {/* <SwiperButtonNext
              nextDayRef={nextDayRefList[nextDayRefList.length - 1]}
            > */}
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            color: "var(--primaryShades20)",
            cursor: "pointer",
          }}
          className="headline2"
          onClick={() => {
            analyticsEvent.clickEvent(
              "Media",
              eventName.Media_next_day_selected
            );
            handleNext();
          }}
        >
          {day.nextDate
            ? dateDDMM(day.nextDate)
            : isEmpty(day.nextDate) && day.nextDay
            ? "Day: " + day.nextDay
            : ""}
          <img
            style={
              day.nextDay
                ? {
                    maxWidth: "7px",
                    marginLeft: "5px",
                    width: "12px",
                    height: "12px",
                  }
                : { visibility: "hidden", marginLeft: "30px" }
            }
            src={rightArrow}
            alt="right-arrow"
          ></img>
        </span>

        {/* // : (
                  //   <span style={{ visibility: 'hidden' }}>None</span>
                  // ) */}
        {/* </SwiperButtonNext> */}
      </div>
      {/* Dates Navigation Slider Ended here */}

      {/* Inner Swiper-Slider-->Child Slider */}
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        // direction={'horizontal'}
        // nested={true}
        loop={false}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className="mediaSwiper"
        onSlideNextTransitionEnd={() => {
          analyticsEvent.clickEvent("Media", eventName.Media_right_swipe);
        }}
        onSlidePrevTransitionEnd={() => {
          analyticsEvent.clickEvent("Media", eventName.Media_left_swipe);
        }}
        onSlideChange={(swiper) => {
          console.log(">>>Active Slide:: ", swiper.activeIndex);
          if (swiper.activeIndex === day.mediaArr.length - 1) {
            setshowNext(true);
            // handleNext()
          } else {
            setshowNext(false);
          }

          if (swiper.activeIndex === 0) {
            setshowPrev(true);
            // handlePrev()
          } else {
            setshowPrev(false);
          }

          // in case of only one slide
          // if (day.mediaArr.length === 1) {
          //   console.log(day.totalStops)
          //   setshowNext(true)
          // }
        }}

        // onReachBeginning={(swiper) => {
        //   handlePrev()
        // }}
        // onReachEnd={(swiper) => {
        //   handleNext()
        // }}
      >
        {day.mediaArr.map((element, index) => {
          // console.log(element.item_id)
          let stayDates = [];
          let stayDay = [];
          if (element.item_type === "HOTEL") {
            stayViewData.forEach((stay) => {
              if (stay.id === element.item_id) {
                stayDates = [...stay.date];
                stayDay = [...stay.day];
              }
            });
          }

          // console.log('>>>>>Duration::', duration)
          return (
            <SwiperSlide key={index}>
              <MediaSlides
                element={element}
                stayDates={stayDates}
                stayDay={stayDay}
                handleDetailPageOpen={handleDetailPageOpen}
                setisMediaMuted={setisMediaMuted}
                isMediaMuted={isMediaMuted}
                detailPageState={detailPageState}
              />
            </SwiperSlide>
          );
        })}
        {day.totalStops === 0 && (
          <SwiperSlide>
            <div>
              <Card
                sx={{
                  maxWidth: "100%",
                  margin: "auto",
                  borderRadius: "8px 8px 8px 8px",
                  cursor: "pointer",
                }}
                variant="outlined"
              >
                <CardMedia
                  component="img"
                  alt="media-pics"
                  // height="250"

                  image={leisureDayBig}
                  sx={{
                    borderRadius: "8px 8px 0px 0px",
                    position: "relative",
                  }}
                  className="media-image-slide"
                />

                <CardContent
                  style={{
                    lineHeight: "10px",
                    height: "105px",
                    padding: "0px 15px",
                    textAlign: "left",
                    borderRadius: "0px 0px 8px 8px",
                  }}
                >
                  <div>
                    <p
                      className="headline2"
                      style={{
                        color: "var(--gray100)",
                        lineHeight: "22.5px",
                        marginTop: "10px",
                      }}
                    >
                      Leisure day
                    </p>
                    <p
                      className="body3"
                      style={{
                        color: "var(--gray80)",
                        lineHeight: "22.5px",
                      }}
                    >
                      Relaxing time
                    </p>
                  </div>
                </CardContent>
              </Card>
              <div style={{ height: "40px" }}></div>
            </div>
          </SwiperSlide>
        )}
        <div>
          {showPrev && (
            <img
              src={newLeft}
              // className="swiper-button-prev"
              style={{
                position: "absolute",
                top: "30%",
                width: "calc(var(--swiper-navigation-size) / 44 * 45)",
                marginTop: "calc(0px - (var(--swiper-navigation-size) / 2))",
                left: "0",
                zIndex: "100",
                // width: '48px',
                height: "100px",
                cursor: "pointer",
                objectFit: "none",
              }}
              onClick={handlePrev}
            ></img>
          )}
          {(showNext || day.mediaArr.length === 1 || day.totalStops === 0) && (
            <img
              // className="swiper-button-next"
              style={{
                position: "absolute",
                top: "30%",
                width: "calc(var(--swiper-navigation-size) / 44 * 45)",
                marginTop: "calc(0px - (var(--swiper-navigation-size) / 2))",
                right: "0",
                zIndex: "100",
                // width: '48px',
                height: "100px",
                cursor: "pointer",
                objectFit: "none",
              }}
              src={newRight}
              onClick={handleNext}
            ></img>
          )}
        </div>
      </Swiper>
      {/* Inner Swiper-Slider-->Child Slider Ended */}
    </div>
  );
}
